import { createPerimeter } from 'vue-kindergarten';
import { isRole } from '../utilities/roleUtilities';

export const TemplatesPerimeter = createPerimeter({
    purpose: 'templates',

    can: {
        read () {
            return isRole.admin(this.child);
        },
        // only admin can edit template
        update () {
            return isRole.admin(this.child);
        },

        // if user can update template then she can also destroy them
        destroy () {
            return this.isAllowed('update');
        }
    }
});
